/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateMedicalIntakeErrorResponse,
  UpdateMedicalIntakeRequest,
  UpdateMedicalIntakeResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersMedicalIntake = (
  encounterId: number,
  updateMedicalIntakeRequest: UpdateMedicalIntakeRequest,
) => {
  return api<UpdateMedicalIntakeResponse>({
    url: `/api/encounters/${encounterId}/medical-intake`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateMedicalIntakeRequest,
  });
};

export const getUpdateEncountersMedicalIntakeMutationOptions = <
  TError = UpdateMedicalIntakeErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersMedicalIntake>>,
    TError,
    { encounterId: number; data: UpdateMedicalIntakeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersMedicalIntake>>,
  TError,
  { encounterId: number; data: UpdateMedicalIntakeRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersMedicalIntake'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersMedicalIntake>>,
    { encounterId: number; data: UpdateMedicalIntakeRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersMedicalIntake(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersMedicalIntakeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersMedicalIntake>>
>;
export type UpdateEncountersMedicalIntakeMutationBody = UpdateMedicalIntakeRequest;
export type UpdateEncountersMedicalIntakeMutationError = UpdateMedicalIntakeErrorResponse;

export const useUpdateEncountersMedicalIntake = <
  TError = UpdateMedicalIntakeErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersMedicalIntake>>,
      TError,
      { encounterId: number; data: UpdateMedicalIntakeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersMedicalIntake>>,
  TError,
  { encounterId: number; data: UpdateMedicalIntakeRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersMedicalIntakeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
